import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import cityLandingPageData from './features/landingpage/data/cityLandingPageData';
import PageLayout from './features/layout/components/PageLayout';

const LandingPage = lazy(() => import('./features/landingpage/components/LandingPage'));
const CityLandingPage = lazy(() => import('./features/landingpage/components/CityLandingPage'));
const App = lazy(() => import('./App'));
const DriversPage = lazy(() => import('./features/drivers/components/DriversPage'));

export default (
    <Suspense fallback={<div />}>
        <Routes>
            <Route element={<PageLayout />}>
                <Route path="/" element={<LandingPage />} />
                <Route path="/drivers" element={<DriversPage />} />
                <Route path="/london" element={<CityLandingPage cityData={cityLandingPageData.london} />} />
                <Route path="/manchester" element={<CityLandingPage cityData={cityLandingPageData.manchester} />} />
                <Route path="/edinburgh" element={<CityLandingPage cityData={cityLandingPageData.edinburgh} />} />
                <Route path="/belfast" element={<CityLandingPage cityData={cityLandingPageData.belfast} />} />
                <Route path="/cardiff" element={<CityLandingPage cityData={cityLandingPageData.cardiff} />} />
                <Route path="/liverpool" element={<CityLandingPage cityData={cityLandingPageData.liverpool} />} />
            </Route>
            <Route path="/map" element={<App />} />
        </Routes>
    </Suspense>
);
